import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _iconChildSize;

export var SKINS = {
  standard: 'standard',
  inverted: 'inverted',
  light: 'light',
  transparent: 'transparent',
  premium: 'premium'
};
export var SIZES = {
  tiny: 'tiny',
  small: 'small',
  medium: 'medium',
  large: 'large'
};
export var PRIORITY = {
  primary: 'primary',
  secondary: 'secondary'
};
export var iconChildSize = (_iconChildSize = {}, _defineProperty(_iconChildSize, SIZES.tiny, '18px'), _defineProperty(_iconChildSize, SIZES.small, '18px'), _defineProperty(_iconChildSize, SIZES.medium, '24px'), _defineProperty(_iconChildSize, SIZES.large, '24px'), _iconChildSize);